import { AiseaApiFactory } from "@/api/aisea/apiFactory";

// 船員年度情報リポジトリ
const enterpriseCrewFiscalYearsRepository = AiseaApiFactory.get(
  "enterpriseCrewFiscalYears"
);

/**
 * 配乗基本情報サービス
 */
const AssignmentBasicInfoService = (() => {
  /**
   * 船員の年度情報一覧を取得
   * @param {String} enterpriseCrewId - 船員ID
   * @returns {Promise<Array>} 年度情報の配列
   */
  const fetch = async enterpriseCrewId => {
    const res = await enterpriseCrewFiscalYearsRepository.fetch(
      enterpriseCrewId
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data.crew_fiscal_years;
  };

  /**
   * 船員の年度情報を更新
   * @param {String} enterpriseCrewId - 船員ID
   * @param {String} enterpriseCrewFiscalYearId - 年度情報ID
   * @param {Object} payload - 更新データ
   * @returns {Promise<Object>} 更新後のデータ
   */
  const update = async (
    enterpriseCrewId,
    enterpriseCrewFiscalYearId,
    payload
  ) => {
    const res = await enterpriseCrewFiscalYearsRepository.update(
      enterpriseCrewId,
      enterpriseCrewFiscalYearId,
      payload
    );
    if (!res || !res.status) {
      throw res;
    }
    return res.data;
  };

  return {
    fetch,
    update,
  };
})();

export default AssignmentBasicInfoService;
